import createBridgeRequest from '../utils/clientRequest';
import createWebProxyRequest from './webProxyRequest';
import config from './config';

/**
 * 请求分发层:按 REACT_APP_API_MODE 在 bridge(jsBridge) 与 proxy(web 调试) 之间选择。
 * 对外导出与旧 createClientRequest(t, i18n) 相同签名,页面仅需把 import 路径改到此处。
 */
const createClientRequest = (t, i18n) =>
  config.mode === 'proxy' ? createWebProxyRequest(t) : createBridgeRequest(t, i18n);

export default createClientRequest;
